import { ActionTypes } from '../constants/index';

export const getNotificationLiveStreaming = (payload: any) => ({
  type: ActionTypes.NOTIFICATION_LIVE_LIST_REQUEST,
  payload,
});
